// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicMobileV1SetOfferReactionRequest,
  TPublicMobileV1SetOfferReactionModel,
  IMappers,
  TPublicMobileV1SetOfferReactionResponse,
  TPublicMobileV1SetOfferReactionResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicMobileV1SetOfferReactionModel(
  parameters: TPublicMobileV1SetOfferReactionRequest,
): TPublicMobileV1SetOfferReactionModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-chat-bot',
    pathApi: '/mobile/v1/set-offer-reaction/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicMobileV1SetOfferReactionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicMobileV1SetOfferReactionRequest;
}

export async function fetchPublicMobileV1SetOfferReaction<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMobileV1SetOfferReactionOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicMobileV1SetOfferReactionResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicMobileV1SetOfferReactionModel(parameters),
    config,
  )) as FetchResponse<TPublicMobileV1SetOfferReactionResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicMobileV1SetOfferReactionResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicMobileV1SetOfferReactionResponse>;
}
